import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment } from 'react';
import { useThemeUI } from 'theme-ui';
import { Col, Row, EVEntry } from '@uswitch/ev-core/react'; // eslint-disable-next-line import/no-anonymous-default-export

import { createElement as _createElement } from "theme-ui";
import { jsx as _jsx } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var _options$styles, _options$styles2;

  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      children = _ref.children,
      _ref$colsMobile = _ref.colsMobile,
      colsMobile = _ref$colsMobile === void 0 ? 1 : _ref$colsMobile,
      _ref$colsTablet = _ref.colsTablet,
      colsTablet = _ref$colsTablet === void 0 ? 2 : _ref$colsTablet,
      _ref$colsDesktop = _ref.colsDesktop,
      colsDesktop = _ref$colsDesktop === void 0 ? 3 : _ref$colsDesktop,
      _ref$divided = _ref.divided,
      divided = _ref$divided === void 0 ? false : _ref$divided,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;
  var rowStyles = (options === null || options === void 0 ? void 0 : (_options$styles = options.styles) === null || _options$styles === void 0 ? void 0 : _options$styles.row) || {};
  var colStyles = (options === null || options === void 0 ? void 0 : (_options$styles2 = options.styles) === null || _options$styles2 === void 0 ? void 0 : _options$styles2.col) || {};

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var offsetDesktop = theme.space.lg;
  var offsetMobile = theme.space.md;
  var rowSx = divided ? _objectSpread({
    mx: [-offsetMobile, -offsetMobile, -offsetDesktop]
  }, rowStyles) : _objectSpread({}, rowStyles);

  var colSx = _objectSpread({
    variant: divided ? 'modules.collectionGrid.colDivided' : 'modules.collectionGrid.col'
  }, colStyles);

  var childrenArray = entries ? entries.map(function (entity, i) {
    return _createElement(EVEntry, _objectSpread(_objectSpread({}, entity), {}, {
      key: i
    }));
  }) : children;
  return _jsx(Fragment, {
    children: _jsx(Row, {
      cols: [colsMobile, colsTablet, colsDesktop],
      direction: "row",
      wrap: true,
      sx: rowSx,
      children: childrenArray.map(function (child, key) {
        return child.props ? _jsx(Col, {
          span: 1,
          sx: colSx,
          children: _jsx(child.type, _objectSpread({}, child.props))
        }, key) : null;
      }, this)
    })
  });
});
//# sourceMappingURL=collection-grid.js.map